export default __webpack_public_path__ + "static/Passing-Strange-Square-14b9cea20b22cede8d846027498c211d.jpg";